import { DqSocketContextData, DqSocketProvider, DqSocketProviderProps } from 'src/utils/socket';
import React, { PropsWithChildren } from 'react';
import APIS from '../../apiUrl';
import { SocketClient } from '../SocketClient';

export const SocketContextPortal = React.createContext<DqSocketContextData>(undefined!);

export const socketClientPortal = new SocketClient(APIS.PORTAL_API);

export const SocketContextPortalProvider: React.FC<
  PropsWithChildren<Omit<DqSocketProviderProps, 'client' | 'Context'>>
> = props => {
  return (
    <DqSocketProvider {...props} Context={SocketContextPortal} client={socketClientPortal}>
      {props.children}
    </DqSocketProvider>
  );
};
